(function (scope) {
  'use strict';
  const clean = value => String(value || '').toLowerCase().normalize('NFKD').replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const hasName = (text, name) => (` ${text} `).includes(` ${clean(name)} `);
  const excluded = /(?:^| )(?:ebook|e book|gift card|oracle|tarot|book|books|sage|palo santo|shipping|insurance|support|guide|guides|private sale|live sale|invoice)(?: |$)/;
  const tagIntent = {
    'protection': 'protection', 'concierge protection': 'protection',
    'stress anxiety': 'calm', 'sleep crystals': 'calm', 'concierge calm': 'calm',
    'confidence courage': 'confidence', 'concierge confidence': 'confidence',
    'love crystals': 'love', 'concierge love': 'love',
    'abundance money': 'abundance', 'concierge abundance': 'abundance',
    'concierge joy': 'joy'
  };
  const collectionIntent = {
    'protection-crystals': 'protection', 'jewellery-for-protection': 'protection',
    'stress-anxiety-crystals': 'calm', 'sleep-crystals-1': 'calm', 'jewellery-for-stress-anxiety': 'calm',
    'confidence-crystals': 'confidence', 'jewellery-for-confidence': 'confidence',
    'love-crystals': 'love', 'jewellery-for-love-self-love': 'love',
    'abundance-crystals': 'abundance', 'jewellery-for-abundance': 'abundance'
  };
  function familiesFor(text, copy) {
    const materialText = text.replace(/\bemerald (?:cut|shape|shaped)\b/g, ' ');
    const found = copy.families.filter(f => f.names.some(n => hasName(materialText, n)));
    if (found.some(f => f.id === 'crazy-lace')) return found.filter(f => f.id !== 'calcite');
    return found;
  }
  function formatFor(product) {
    const text = clean(product.title);
    const tags = (product.tags || []).map(clean);
    const collections = (product.collections || []).map(clean);
    const jewellery = /\b(bracelets?|bangles?|necklaces?|pendants?|earrings?|ear rings?|studs?|rings?|anklets?|brooch(?:es)?|cuffs?)\b/;
    if (jewellery.test(text) || tags.concat(collections).some(t => jewellery.test(t) || /\b(jewellery|jewelry)\b/.test(t))) return 'wear';
    for (const format of ['wear', 'carry', 'display']) if (tags.includes('concierge '+format)) return format;
    if (/\b(tumble|tumbled|tumbles|palm|palmstone|worry|pocket)\b/.test(text)) return 'carry';
    if (/\b(stand|stands|tower|towers|vase|bowl|dish|plate|cluster|clusters|cave|caves|wings|pyramid|sphere|spheres|geode|carving|carvings|freeform|point|points|generator|heart|hearts|moon|moons)\b/.test(text)) return 'display';
    return null;
  }
  function candidates(products, copy) {
    const rows = [];
    for (const p of products) {
      if (!p || !p.available || !p.url || !Array.isArray(p.variants)) continue;
      const tags = (p.tags || []).map(clean);
      const collections = p.collections || [];
      const text = clean(p.title);
      if (excluded.test(text) || tags.some(t => /live and private|live sale|concierge exclude/.test(t)) || collections.some(c => /live.sale|private.sale/.test(c))) continue;
      const format = formatFor({...p, tags: p.tags || []});
      const productFamilies = familiesFor(text, copy);
      const materialVariants = p.variants.some(v => familiesFor(clean(v.title), copy).length > 0);
      for (const v of p.variants) {
        if (!v.available || !Number.isFinite(Number(v.price)) || Number(v.price) <= 0) continue;
        const ownFamilies = familiesFor(clean(v.title), copy);
        const families = materialVariants ? ownFamilies : productFamilies;
        if (materialVariants && !ownFamilies.length) continue;
        const weights = {};
        for (const f of families) for (const [need, weight] of Object.entries(f.weights)) weights[need] = Math.max(weights[need] || 0, weight);
        if (!families.length) {
          for (const tag of tags) if (tagIntent[tag]) weights[tagIntent[tag]] = 2;
          for (const col of collections) if (collectionIntent[col]) weights[collectionIntent[col]] = 2;
        }
        if (!Object.keys(weights).length) continue;
        const family = families[0];
        const variantName = v.title && v.title !== 'Default Title' ? v.title : '';
        const url = new URL(p.url, 'https://quartzed.invalid');
        url.searchParams.set('variant', String(v.id));
        rows.push({
          productId: String(p.id), id: String(v.id), handle: p.handle,
          title: p.title, variant: variantName, url: url.pathname + url.search,
          image: v.image || p.image || '', price: Number(v.price), formatted: v.formatted,
          format, families: families.map(f => f.id), family: family?.id || p.handle,
          weights, explanation: family?.reason || '', role: family?.role || '',
          requiresSize: /\bring\b/.test(text), available: true
        });
      }
    }
    return rows;
  }
  function budgetFor(answers, copy) {
    return copy.questions.find(q => q.key === 'budget').options.find(o => o.id === answers.budget);
  }
  function ranked(products, answers, copy, cartIds = []) {
    const budget=budgetFor(answers,copy);
    if (!budget || !copy.needs[answers.need]) return [];
    const all=candidates(products,copy), cart=new Set(cartIds.map(String));
    let pool=all.filter(p=>!cart.has(p.id));
    if(!pool.length)pool=all;
    if(!pool.length)return [];
    const physical=p=>p.format==='display'||p.format==='carry';
    const category=answers.format==='wear'?pool.filter(p=>p.format==='wear'):
      answers.format==='any'?pool:pool.filter(physical);
    if(category.length)pool=category;
    const inBudget=p=>p.price>=budget.min&&(budget.max==null||p.price<budget.max);
    const affordable=pool.filter(inBudget);
    if(affordable.length)pool=affordable;
    else {
      const lower=pool.filter(p=>p.price<budget.min);
      if(lower.length)pool=lower;
    }
    const sameFormat=pool.filter(p=>answers.format==='any'||p.format===answers.format);
    if(sameFormat.length)pool=sameFormat;
    const struggle=copy.questions[0].options.find(o=>o.id===answers.struggle)?.need;
    const related={protection:['calm','confidence'],calm:['protection','love'],confidence:['abundance','joy'],love:['calm','joy'],abundance:['confidence','joy'],joy:['confidence','love']};
    const relevance=weights=>10*(weights[answers.need]||0)+(struggle?3*(weights[struggle]||0):0)+((weights[answers.need]||0)>0?0:Math.max(0,...(related[answers.need]||[]).map(n=>weights[n]||0)));
    const gap=p=>inBudget(p)?0:p.price<budget.min?budget.min-p.price:p.price-budget.max+1;
    return pool.map(p=>{
      const profile=copy.families.filter(f=>p.families.includes(f.id)).sort((a,b)=>(Number((b.weights[answers.need]||0)>0)-Number((a.weights[answers.need]||0)>0))||relevance(b.weights)-relevance(a.weights))[0];
      return {...p,family:profile?.id||p.family,explanation:profile?.reason||p.explanation,role:profile?.role||p.role,score:relevance(p.weights),inCart:cart.has(p.id),fit:{budget:inBudget(p),format:answers.format==='any'||p.format===answers.format,intention:(p.weights[answers.need]||0)>0}};
    }).sort((a,b)=>gap(a)-gap(b)||Number(b.fit.intention)-Number(a.fit.intention)||b.score-a.score||(budget.max==null?0:a.price-b.price));
  }
  function recommend(products, answers, copy, cartIds = []) {
    const sorted = ranked(products, answers, copy, cartIds);
    const picks = [], usedProducts = new Set(), usedFamilies = new Set();
    for (const p of sorted) {
      if (picks.length === 3) break;
      if (!usedProducts.has(p.productId) && !usedFamilies.has(p.family)) {
        picks.push(p); usedProducts.add(p.productId); usedFamilies.add(p.family);
      }
    }
    for (const p of sorted) {
      if (picks.length === 3) break;
      if (!usedProducts.has(p.productId)) { picks.push(p); usedProducts.add(p.productId); }
    }
    const lead = picks[0];
    let pair = null;
    if (lead && !lead.requiresSize && !lead.inCart && lead.fit.budget && lead.fit.format && lead.fit.intention) {
      const budget = budgetFor(answers, copy);
      const struggle = copy.questions[0].options.find(o => o.id === answers.struggle)?.need;
      const partners = candidates(products, copy).filter(p =>
        p.productId !== lead.productId && !p.requiresSize && !cartIds.map(String).includes(p.id) &&
        (answers.format === 'any' || p.format === answers.format) &&
        (budget.max == null || (p.price <= Math.max(2000, lead.price * 1.25) && p.price + lead.price < budget.max))
      );
      const options = [];
      for (const rule of copy.pairs) {
        if (!rule.needs.includes(answers.need)) continue;
        for (const partner of partners) {
          const match = lead.families.includes(rule.a) && partner.families.includes(rule.b) || lead.families.includes(rule.b) && partner.families.includes(rule.a);
          if (!match) continue;
          const score = (partner.weights[answers.need] || 0) * 10 + (struggle ? (partner.weights[struggle] || 0) * 5 : 0);
          options.push({rule, items:[lead, partner], total:lead.price+partner.price, score});
        }
      }
      pair = options.sort((a,b) => b.score-a.score || (budget.max == null ? 0 : a.total-b.total))[0] || null;
    }
    return {picks, pair};
  }
  scope.QuartzedConcierge = Object.freeze({candidates, recommend, budgetFor, clean});
})(typeof window === 'undefined' ? globalThis : window);

